<template>
  <div class="content3 contentPage swiper-slide" :class="nowPage === 2 ? 'cartoon' : ''">
    <ul class="navList">
      <li :class="`itemNav cartoon${index + 1}`" v-for="(item, index) in navList" :key="item.id" @click="mySlideTo(item.id)">
        <img :src="item.aniImg" class="aniImg" :style="{left: item.left +'px', top: item.top +'px'}">
        <img :src="item.enTxt" class="enTxt"/>
        <div class="heng"></div>
        <p class="type">{{item.type}}</p>
        <p class="title">{{item.title}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import { navList } from './data'

export default {
  mixins: [swiperMixin],
  data () {
    return {
      navList,
    }
  },

  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },

  methods: {
    // 显示作品列表
    changeShowWorkList () {
      this.showContent = !this.showContent
    },


  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './content3.styl'
</style>